import dayjs from 'dayjs';
import styles from './timesheet-table.module.scss';
import cx from 'classnames';
import { getItalianHolidays } from 'src/utils/holidays-utils';

type Props = {
  year: number;
  month: number;
  days: number;
};

const TimesheetTableHeader = (props: Props) => {
  const { month, days, year } = props;

  const renderDay = (index: number) => {
    const day = dayjs()
      .month(month)
      .date(index + 1)
      .format('dddd');

    const holidays = getItalianHolidays(year, 'Rome');

    const isHoliday =
      holidays.some(holiday =>
        dayjs(holiday.date).isSame(
          dayjs()
            .year(year)
            .month(month)
            .date(index + 1),
          'day'
        )
      ) ||
      day === 'Saturday' ||
      day === 'Sunday';

    const classNames = cx(styles.day, {
      [styles.holidayBackground]: isHoliday,
    });
    return (
      <th className={classNames} key={index}>
        {index + 1}
      </th>
    );
  };

  const renderDays = () => {
    return Array.from({ length: days }, (_, index) => renderDay(index));
  };

  return (
    <tr className={styles.TimesheetTableHeaderContainer}>
      <th className={styles.day}></th>
      {renderDays()}
      <th className={styles.day}>Totale ore commessa</th>
    </tr>
  );
};

export default TimesheetTableHeader;
